<div class="error-component">
  <h2>Invalid login, please try again!</h2>
  <button mat-button class="goBack" (click)="goBack()">Go Back</button>
</div>
